<template>
    <div>
        <div class="row justify-content-center">
          <div class="col-md-7" 
           :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <br>
            <br>
            <p class=" text-3xl sm:text-5xl font-semibold text-center wow"
            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
             style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">
                PETA
            </p>
            <div style="" 
              class="d-flex justify-content-center align-items-center shadow-lg rounded-lg">
              <br>
                  <div style="width:100%" class=" ">
                      <div class="row justify-content-center">
                        <div class="col-10 text-center wow"
                        :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                        >
                           <iframe src="https://www.google.com/maps/d/embed?mid=1oNN0N4R0-E22-NdfxfQZIbA_9Y2Ds92X" style="width:100%;" height="480"></iframe>
                        </div>
                    </div>
                  </div>
              </div>
               <br>
               <div class="row justify-content-center">
                 <div class="col-8">
                    <!-- <div class="text-center mt-4">
                      <a :href="`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${$store.state.data.undangan.lokasi_akad}`">
                        <button type="button" class="btn btn-sm btn-style8  btn-block"><span class="typcn typcn-map"></span>Route Ke Akad Nikah</button>
                      </a>
                    </div> -->
                      <div class="text-center mt-4" v-for="(item, index) in $store.state.data.acara" :key="index+'acaras'">
                        <a :href="`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${item.lokasi_acara}`">
                          <button type="button" class="btn btn-sm btn-style10 btn-block "><span class="typcn typcn-map"></span>Route Ke {{item.judul_acara}}</button>
                        </a>
                    </div>
                 </div>
               </div>
               <br>

            <br>
             <br>
          </div>
        </div>
    </div>
</template>
<script>
export default{
  props:['particle'],

}
</script>